export default __webpack_public_path__ + "static/media/icon_success_sale.26912f60.svg";